import { twMerge } from 'utilities/src/twMerge';
import React from 'react';

type AccordionSeparatorProps = {
  classes?: string;
};

function AccordionSeparator({ classes = '' }: AccordionSeparatorProps) {
  return <hr className={twMerge('h-1 w-full border-white bg-white', classes)} />;
}

export default AccordionSeparator;
